export default __webpack_public_path__ + "static/media/links.d6683d04.svg";